import React from 'react'
import './LineSPF.scss'

function Tooltip({ position = [0, 0], fontColor = '#ffffff', backgroundColor, content = '' }) {
	return (
		<div
			className='line-spf__tooltip'
			style={{
				'--x-position': `${position[0]}px`,
				'--y-position': `${position[1]}px`,
			}}
		>
			<div
				className='line-spf__tooltip-arrow'
				style={{
					'--custom-bg-color-arrow': `${backgroundColor}`,
				}}
			/>
			<div
				className='line-spf__tooltip-content'
				style={{
					'--custom-bg-color-content': `${backgroundColor}`,
					'--custom-font-color': `${fontColor}`,
				}}
			>
				{content}
			</div>
		</div>
	)
}

export default Tooltip
